import { Link } from "react-router-dom";
import { Button } from "@/platform/ui";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="mono text-4xl font-bold text-faint">404</div>
      <p className="mt-2 text-sm text-muted">This page doesn’t exist.</p>
      <Link to="/" className="mt-4">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
